<template>
  <DxDropDownBox
    :value="value"
    :data-source="flatData"
    :show-clear-button="true"
    :input-attr="{ 'aria-label': 'Period Select' }"
    value-expr="ID"
    display-expr="name"
    placeholder="Выберите период..."
    :style="{ width: typeof width === 'number' ? width + 'px' : width }"
    @value-changed="onValueChanged"
    :disabled="disable"
  >
    <template #content>
      <DxTreeView
        ref="treeView"
        :data-source="flatData"
        :select-by-click="true"
        :select-nodes-recursive="true"
        data-structure="plain"
        key-expr="ID"
        parent-id-expr="categoryId"
        selection-mode="multiple"
        show-check-boxes-mode="normal"
        display-expr="name"
        @content-ready="onTreeReady"
        @item-selection-changed="onTreeSelectionChanged"
      />
    </template>
  </DxDropDownBox>
</template>

<script>
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';

export default {
  name: 'DPeriodTreeSelect',
  components: { DxDropDownBox, DxTreeView },
  props: {
    value: { type: Array, default: () => [] },
    width: { type: [String, Number], default: '217px' },
    disable: { type: Boolean, default: false }
  },
  data() {
    const flatData = [
      { ID: 'months', name: 'Месяцы', categoryId: null },
      { ID: 'january', name: 'Январь', categoryId: 'months' },
      { ID: 'february', name: 'Февраль', categoryId: 'months' },
      { ID: 'march', name: 'Март', categoryId: 'months' },
      { ID: 'april', name: 'Апрель', categoryId: 'months' },
      { ID: 'may', name: 'Май', categoryId: 'months' },
      { ID: 'june', name: 'Июнь', categoryId: 'months' },
      { ID: 'july', name: 'Июль', categoryId: 'months' },
      { ID: 'august', name: 'Август', categoryId: 'months' },
      { ID: 'september', name: 'Сентябрь', categoryId: 'months' },
      { ID: 'october', name: 'Октябрь', categoryId: 'months' },
      { ID: 'november', name: 'Ноябрь', categoryId: 'months' },
      { ID: 'december', name: 'Декабрь', categoryId: 'months' },
      { ID: 'quarters', name: 'Кварталы', categoryId: null },
      { ID: 'first_quarter', name: 'I квартал', categoryId: 'quarters' },
      { ID: 'second_quarter', name: 'II квартал', categoryId: 'quarters' },
      { ID: 'third_quarter', name: 'III квартал', categoryId: 'quarters' },
      { ID: 'thourth_quarter', name: 'IV квартал', categoryId: 'quarters' },
      { ID: 'halfyears', name: 'Полугодия', categoryId: null },
      { ID: 'first_half', name: '1 полугодие', categoryId: 'halfyears' },
      { ID: 'second_half', name: '2 полугодие', categoryId: 'halfyears' },
      { ID: 'year', name: 'Год', categoryId: null },
      { ID: 'year_item', name: 'Год', categoryId: 'year' },
      { ID: 'growth', name: 'Нарастание', categoryId: null },
      { ID: 'a_month', name: '1 мес.(янв)', categoryId: 'growth' },
      { ID: 'two_months', name: '2 мес.(янв-фев)', categoryId: 'growth' },
      { ID: 'three_months', name: '3 мес.(янв-мар)', categoryId: 'growth' },
      { ID: 'four_months', name: '4 мес.(янв-апр)', categoryId: 'growth' },
      { ID: 'five_months', name: '5 мес.(янв-май)', categoryId: 'growth' },
      { ID: 'six_months', name: '6 мес.(янв-июн)', categoryId: 'growth' },
      { ID: 'seven_months', name: '7 мес.(янв-июл)', categoryId: 'growth' },
      { ID: 'eight_months', name: '8 мес.(янв-авг)', categoryId: 'growth' },
      { ID: 'nine_months', name: '9 мес.(янв-сен)', categoryId: 'growth' },
      { ID: 'ten_months', name: '10 мес.(янв-окт)', categoryId: 'growth' },
      { ID: 'eleven_months', name: '11 мес.(янв-ноя)', categoryId: 'growth' },
      { ID: 'twelve_months', name: '12 мес.(янв-дек)', categoryId: 'growth' },
      { ID: 'wane', name: 'Убывание', categoryId: null },
      { ID: 'wane_twelve_months', name: '12 мес.(янв-дек)', categoryId: 'wane' },
      { ID: 'wane_eleven_months', name: '11 мес.(фев-дек)', categoryId: 'wane' },
      { ID: 'wane_ten_months', name: '10 мес.(мар-дек)', categoryId: 'wane' },
      { ID: 'wane_nine_months', name: '9 мес.(апр-дек)', categoryId: 'wane' },
      { ID: 'wane_eight_months', name: '8 мес.(май-дек)', categoryId: 'wane' },
      { ID: 'wane_seven_months', name: '7 мес.(июн-дек)', categoryId: 'wane' },
      { ID: 'wane_six_months', name: '6 мес.(июл-дек)', categoryId: 'wane' },
      { ID: 'wane_five_months', name: '5 мес.(авг-дек)', categoryId: 'wane' },
      { ID: 'wane_four_months', name: '4 мес.(сен-дек)', categoryId: 'wane' },
      { ID: 'wane_three_months', name: '3 мес.(окт-дек)', categoryId: 'wane' },
      { ID: 'wane_two_months', name: '2 мес.(ноя-дек)', categoryId: 'wane' },
      { ID: 'wane_a_month', name: '1 мес.(дек)', categoryId: 'wane' }
    ];

    // Кэшируем корневые узлы
    const rootNodeIds = flatData.filter(item => item.categoryId === null).map(item => item.ID);

    // Создаем карту родитель-дети для оптимизации getDescendantIds
    const parentToChildrenMap = {};
    flatData.forEach(item => {
      if (item.categoryId) {
        if (!parentToChildrenMap[item.categoryId]) {
          parentToChildrenMap[item.categoryId] = [];
        }
        parentToChildrenMap[item.categoryId].push(item.ID);
      }
    });

    const monthsExpandedOnce = false

    return {
      flatData,
      rootNodeIds,
      parentToChildrenMap,
      monthsExpandedOnce
    };
  },
  watch: {
    value: {
      handler(newValue) {
        this.syncTreeViewSelection();
      },
      deep: true
    }
  },
  methods: {
    getDescendantIds(nodeId) {
      const descendants = [];
      const queue = [nodeId];
      while (queue.length > 0) {
        const currentId = queue.shift();
        const children = this.parentToChildrenMap[currentId] || [];
        descendants.push(...children);
        queue.push(...children);
      }
      return descendants;
    },
    onTreeReady({ component }) {
      this.treeView = component;
      if (component) {
        // раскрываем нужные ветви при загрузке
        if(!this.monthsExpandedOnce){
        this.$nextTick(() => {
          component.expandItem('months'); // раскрыть "Месяцы"
          this.monthsExpandedOnce = true
        });
      }

        this.syncTreeViewSelection();
      } else {
        console.error('TreeView instance is not available');
      }
    },
    onTreeSelectionChanged(e) {
      this.$emit('input', e.component.getSelectedNodeKeys());
    },
   onValueChanged(e) {
      const selectedIds = Array.isArray(e.value) ? e.value : [];
      this.$emit('input', selectedIds);

      const tree = this.$refs.treeView && this.$refs.treeView.instance;
      if (tree && selectedIds.length === 0) {
        tree.unselectAll();
      }
    },
    
    syncTreeViewSelection() {
      const tree = this.$refs.treeView && this.$refs.treeView.instance;
      if (!tree) return;

      // Оптимизация: выбираем только необходимые узлы
      const currentSelectedKeys = tree.getSelectedNodeKeys();
      const targetKeys = Array.isArray(this.value) ? this.value : [];

      // Снимаем выделение только с узлов, которые не в targetKeys
      currentSelectedKeys.forEach(id => {
        if (!targetKeys.includes(id)) {
          try {
            tree.unselectItem(id);
          } catch (error) {
            console.warn(`Не удалось снять выделение с элемента ID: ${id}`);
          }
        }
      });

      // Выбираем только узлы, которые еще не выбраны
      targetKeys.forEach(id => {
        if (!currentSelectedKeys.includes(id)) {
          try {
            tree.selectItem(id);
          } catch (error) {
            console.warn(`Не удалось выбрать элемент с ID: ${id}`);
          }
        }
      });

      var dropDown = this.$refs.treeView && this.$refs.treeView.element && this.$refs.treeView.element.closest('.dx-dropdownbox') && this.$refs.treeView.element.closest('.dx-dropdownbox').dxDropDownBox('instance');
      if (dropDown) {
        const selectedNodes = this.flatData.filter(item => targetKeys.includes(item.ID));
        const displayText = selectedNodes.map(node => node.name).join(', ');
        dropDown.option('displayValue', displayText || 'Выберите период...');
      }
    }
  }
};
</script>
